import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetovasaivirarcab() {



  const cardData = {


  keyword: "Pune to Vasai & Virar Cab",

  headingDescription: "Trustline Cab provides reliable Pune to Vasai & Virar cab services with safe, comfortable, and affordable transportation for business travel, family trips, airport transfers, corporate journeys, medical visits, and outstation travel. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth driving, and a stress-free journey. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium vehicles suitable for every travel requirement. With transparent pricing, doorstep pickup, easy online booking, flexible schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Vasai & Virar taxi services.",

  topPlaces: [
    {
      title: "Vasai",
      description: "Vasai is a rapidly developing suburb in the Mumbai Metropolitan Region, known for residential communities, commercial establishments, historical attractions, beaches, and excellent connectivity. It is an important destination for families, professionals, and travelers visiting the western suburbs of Mumbai."
    },
    {
      title: "Virar",
      description: "Virar is one of the fastest-growing areas near Mumbai, offering residential projects, business zones, beaches, temples, and recreational destinations. With expanding infrastructure and connectivity, it has become a popular location for daily commuters and outstation travelers."
    },
    {
      title: "Mira Road",
      description: "Mira Road is a major residential and commercial locality in the Mumbai Metropolitan Region, featuring shopping complexes, corporate offices, hospitals, educational institutions, and modern infrastructure. It is a preferred destination for professionals and families traveling across Mumbai."
    },
    {
      title: "Borivali",
      description: "Borivali is a well-developed western suburb of Mumbai known for business establishments, shopping areas, residential societies, and excellent connectivity. It is also a gateway to Sanjay Gandhi National Park and nearby tourist attractions."
    },
    {
      title: "Goregaon",
      description: "Goregaon is an important commercial and business hub featuring IT parks, corporate offices, exhibition centers, entertainment zones, and modern residential developments. It attracts professionals, business travelers, and visitors throughout the year."
    },
    {
      title: "Mindspace Malad",
      description: "Mindspace Malad is a premium business park housing multinational companies, IT firms, financial institutions, and modern office spaces. It is one of Mumbai's leading corporate destinations for technology and business operations."
    },
    {
      title: "Vasai Fort",
      description: "Vasai Fort is a historic Portuguese-era monument known for its ancient ruins, impressive architecture, and cultural importance. Surrounded by scenic landscapes, it is a popular attraction for history lovers, photographers, and tourists."
    },
    {
      title: "Aksa Beach",
      description: "Aksa Beach is a peaceful coastal destination near Mumbai, famous for its clean shoreline, relaxing atmosphere, scenic sunsets, and refreshing sea breeze. It is a popular weekend getaway for visitors looking for a quiet beach experience."
    },
    {
      title: "Sanjay Gandhi National Park",
      description: "Sanjay Gandhi National Park is a famous urban forest offering wildlife experiences, nature trails, boating, greenery, and ancient Kanheri Caves. It is one of Mumbai's best destinations for nature lovers and families."
    },
    {
      title: "Global Vipassana Pagoda",
      description: "Global Vipassana Pagoda is a magnificent meditation monument near Gorai, known for its golden dome, peaceful environment, and impressive architecture. It attracts visitors interested in spirituality, meditation, and unique cultural experiences."
    }
  ],






"services": [
  {
    "name": "Pune to Vasai Cab",
    "description": "Book a Pune to Vasai Cab for safe, comfortable, and affordable long-distance travel with professional chauffeurs and clean AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUV, and premium cars for one-way trips, round trips, family journeys, business travel, Vasai connectivity, and outstation transportation. Enjoy doorstep pickup, transparent pricing, experienced drivers, well-maintained vehicles, flexible booking options, and 24x7 customer support for a smooth travel experience."
  },
  {
    "name": "Pune to Vasai Cab Service",
    "description": "Our Pune to Vasai Cab Service provides reliable intercity taxi solutions with punctual pickup, professional drivers, sanitized AC vehicles, affordable fares, and comfortable travel options. Book one-way, round-trip, private, airport transfer, and corporate cab services with multiple vehicle choices including Sedan, Ertiga, Innova Crysta, and SUV."
  },
  {
    "name": "Pune to Vasai Taxi",
    "description": "Choose Pune to Vasai Taxi service for convenient and hassle-free travel with chauffeur-driven cars, transparent pricing, comfortable seating, and safe highway journeys. Ideal for family trips, business meetings, weekend travel, railway station transfers, and personal transportation needs."
  },
  {
    "name": "Pune to Vasai Taxi Service",
    "description": "Book Pune to Vasai Taxi Service with experienced chauffeurs, premium vehicles, affordable taxi fares, flexible schedules, and reliable customer assistance. Our taxi service ensures comfortable and secure travel from Pune to Vasai with timely pickup and professional service."
  },
  {
    "name": "Pune to Vasai Cab Booking",
    "description": "Complete your Pune to Vasai Cab Booking with easy online reservation, instant confirmation, transparent fares, and multiple vehicle options. Select Sedan, Ertiga, Innova Crysta, or SUV cabs for business travel, family tours, and outstation journeys."
  },
  {
    "name": "Book Pune to Vasai Cab",
    "description": "Book Pune to Vasai Cab anytime for comfortable intercity transportation with professional drivers, clean AC vehicles, affordable pricing, and dependable support. Enjoy convenient doorstep pickup and customized travel solutions according to your schedule."
  },
  {
    "name": "Online Pune to Vasai Cab Booking",
    "description": "Use Online Pune to Vasai Cab Booking to reserve your preferred vehicle quickly with instant confirmation, secure booking options, transparent pricing, and professional chauffeur service for a stress-free journey."
  },
  {
    "name": "Pune to Vasai One Way Cab",
    "description": "Choose Pune to Vasai One Way Cab for affordable single-side travel without return charges. Enjoy comfortable vehicles, experienced chauffeurs, fixed pricing, and reliable transportation for personal, business, and family trips."
  },
  {
    "name": "Pune to Vasai Round Trip Cab",
    "description": "Book Pune to Vasai Round Trip Cab with flexible return timing, premium vehicles, affordable packages, and professional drivers. Perfect for family visits, business travel, sightseeing, and planned return journeys."
  },
  {
    "name": "Pune to Vasai Outstation Cab",
    "description": "Travel safely with Pune to Vasai Outstation Cab service featuring experienced drivers, clean vehicles, comfortable highway travel, and reliable long-distance transportation for all types of journeys."
  },
  {
    "name": "Pune to Vasai Car Rental",
    "description": "Choose Pune to Vasai Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles. Suitable for corporate travel, family trips, private tours, and comfortable outstation transportation."
  },
  {
    "name": "Pune to Vasai Private Cab",
    "description": "Hire Pune to Vasai Private Cab for exclusive travel with complete privacy, flexible pickup locations, comfortable seating, experienced chauffeurs, and personalized travel service."
  },
  {
    "name": "Pune to Vasai AC Cab",
    "description": "Book Pune to Vasai AC Cab with well-maintained air-conditioned vehicles, comfortable interiors, professional drivers, and reliable intercity taxi service for a pleasant journey."
  },
  {
    "name": "Pune to Vasai Intercity Cab",
    "description": "Our Pune to Vasai Intercity Cab service provides safe and affordable city-to-city transportation with premium vehicles, experienced chauffeurs, timely pickup, and comfortable travel solutions."
  },
  {
    "name": "Pune to Vasai Drop Taxi",
    "description": "Choose Pune to Vasai Drop Taxi for direct destination travel with transparent pricing, comfortable AC cars, professional drivers, and convenient doorstep pickup service."
  },
  {
    "name": "Pune to Vasai Travel Cab",
    "description": "Book Pune to Vasai Travel Cab for family vacations, business trips, weekend travel, and private journeys with clean vehicles, skilled chauffeurs, and affordable travel packages."
  },
  {
    "name": "Pune to Vasai Taxi Booking",
    "description": "Complete Pune to Vasai Taxi Booking online with quick confirmation, flexible vehicle selection, affordable fares, and reliable taxi service for comfortable long-distance travel."
  },
  {
    "name": "Pune to Vasai Cab Hire",
    "description": "Hire Pune to Vasai Cab with professional chauffeur service, premium vehicles, transparent pricing, and flexible travel options designed for convenient intercity journeys."
  },
  {
    "name": "Pune to Vasai Rental Cab",
    "description": "Choose Pune to Vasai Rental Cab with Sedan, Ertiga, Innova Crysta, and SUV options for flexible travel, corporate requirements, family trips, and private transportation."
  },
  {
    "name": "Pune to Virar Cab",
    "description": "Book Pune to Virar Cab for comfortable and affordable outstation travel with professional drivers, AC vehicles, doorstep pickup, and reliable transportation options for families, businesses, and personal trips."
  },
  {
    "name": "Pune to Virar Cab Service",
    "description": "Pune to Virar Cab Service offers dependable taxi solutions with clean vehicles, experienced chauffeurs, affordable fares, and flexible booking options for one-way and round-trip travel."
  },
  {
    "name": "Pune to Virar Taxi",
    "description": "Choose Pune to Virar Taxi for safe and convenient travel with premium cars, transparent pricing, comfortable seating, and professional chauffeur-driven service."
  },
  {
    "name": "Pune to Virar Taxi Service",
    "description": "Book Pune to Virar Taxi Service with reliable drivers, well-maintained vehicles, affordable rates, and 24x7 support for comfortable intercity transportation."
  },
  {
    "name": "Pune to Virar Cab Booking",
    "description": "Complete Pune to Virar Cab Booking with easy online reservation, instant confirmation, multiple car choices, and affordable travel packages."
  },
  {
    "name": "Book Pune to Virar Cab",
    "description": "Book Pune to Virar Cab for safe highway travel with professional chauffeurs, spacious vehicles, transparent fares, and comfortable long-distance journeys."
  },
  {
    "name": "Online Pune to Virar Cab Booking",
    "description": "Reserve Online Pune to Virar Cab Booking with quick confirmation, secure booking process, flexible vehicle options, and trusted taxi services."
  },
  {
    "name": "Pune to Virar One Way Cab",
    "description": "Choose Pune to Virar One Way Cab for economical one-side travel with affordable fares, comfortable cars, and experienced drivers."
  },
  {
    "name": "Pune to Virar Round Trip Cab",
    "description": "Book Pune to Virar Round Trip Cab for flexible return travel with premium vehicles, professional chauffeurs, and customized travel packages."
  },
  {
    "name": "Pune to Virar Outstation Cab",
    "description": "Travel with Pune to Virar Outstation Cab featuring safe highway journeys, clean AC vehicles, experienced drivers, and reliable service."
  },
  {
    "name": "Pune to Virar Car Rental",
    "description": "Choose Pune to Virar Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium cars for comfortable travel."
  },
  {
    "name": "Pune to Virar Private Cab",
    "description": "Hire Pune to Virar Private Cab for personalized travel with privacy, flexible pickup, professional chauffeurs, and premium vehicle options."
  },
  {
    "name": "Pune to Virar AC Cab",
    "description": "Book Pune to Virar AC Cab with comfortable air-conditioned cars, experienced drivers, and reliable transportation service."
  },
  {
    "name": "Pune to Virar Intercity Cab",
    "description": "Pune to Virar Intercity Cab provides safe city-to-city travel with affordable pricing, professional drivers, and comfortable vehicles."
  },
  {
    "name": "Pune to Virar Drop Taxi",
    "description": "Choose Pune to Virar Drop Taxi for direct travel with transparent fares, doorstep pickup, and comfortable AC vehicles."
  },
  {
    "name": "Pune to Virar Travel Cab",
    "description": "Book Pune to Virar Travel Cab for family trips, business journeys, and private travel with reliable drivers and premium cars."
  },
  {
    "name": "Hinjewadi to Vasai Cab",
    "description": "Book Hinjewadi to Vasai Cab with doorstep pickup, affordable fares, clean AC vehicles, and professional chauffeurs for comfortable travel."
  },
  {
    "name": "Wakad to Vasai Cab",
    "description": "Choose Wakad to Vasai Cab for reliable intercity transportation with premium vehicles, experienced drivers, and flexible travel options."
  },
  {
    "name": "Baner to Vasai Cab",
    "description": "Hire Baner to Vasai Cab for safe and comfortable travel with chauffeur-driven vehicles, transparent pricing, and dependable service."
  },
  {
    "name": "Kharadi to Vasai Cab",
    "description": "Book Kharadi to Vasai Cab with professional drivers, clean vehicles, affordable fares, and convenient pickup facilities."
  },
  {
    "name": "Hadapsar to Vasai Cab",
    "description": "Choose Hadapsar to Vasai Cab for comfortable outstation travel with reliable taxi service, premium cars, and experienced chauffeurs."
  },
  {
    "name": "Pimpri Chinchwad to Vasai Cab",
    "description": "Book Pimpri Chinchwad to Vasai Cab with affordable pricing, spacious vehicles, professional drivers, and safe highway travel."
  },
  {
    "name": "Hinjewadi to Virar Cab",
    "description": "Reserve Hinjewadi to Virar Cab for comfortable travel with clean AC cars, experienced chauffeurs, and affordable cab service."
  },
  {
    "name": "Wakad to Virar Cab",
    "description": "Book Wakad to Virar Cab with reliable pickup, premium vehicles, transparent fares, and professional chauffeur service."
  },
  {
    "name": "Baner to Virar Cab",
    "description": "Choose Baner to Virar Cab for convenient travel with comfortable vehicles, skilled drivers, and affordable pricing."
  },
  {
    "name": "Kharadi to Virar Cab",
    "description": "Hire Kharadi to Virar Cab with AC cars, experienced chauffeurs, flexible booking, and safe long-distance travel."
  },
  {
    "name": "Hadapsar to Virar Cab",
    "description": "Book Hadapsar to Virar Cab for affordable intercity transportation with premium vehicles and professional drivers."
  },
  {
    "name": "Pimpri Chinchwad to Virar Cab",
    "description": "Choose Pimpri Chinchwad to Virar Cab service with comfortable cars, reliable chauffeurs, and hassle-free booking."
  },
  {
    "name": "Affordable Pune to Vasai and Virar Cab",
    "description": "Book Affordable Pune to Vasai and Virar Cab service with budget-friendly fares, premium vehicles, professional drivers, and reliable transportation for family trips, business travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Best Pune to Vasai Cab Service",
    "description": "Choose Best Pune to Vasai Cab Service for premium travel experience with affordable fares, well-maintained vehicles, experienced chauffeurs, flexible booking options, and 24x7 customer support."
  },
  {
    "name": "Best Pune to Virar Cab Service",
    "description": "Choose Best Pune to Virar Cab Service for safe and comfortable travel with professional drivers, premium AC vehicles, transparent pricing, and reliable outstation cab solutions."
  }
],

"tableData": [
  ["Pune to Vasai Cab", "Pune to Vasai Cab Service"],
  ["Pune to Vasai Taxi", "Pune to Vasai Taxi Service"],
  ["Pune to Vasai Cab Booking", "Book Pune to Vasai Cab"],
  ["Online Pune to Vasai Cab Booking", "Pune to Vasai One Way Cab"],
  ["Pune to Vasai Round Trip Cab", "Pune to Vasai Outstation Cab"],
  ["Pune to Vasai Car Rental", "Pune to Vasai Private Cab"],
  ["Pune to Vasai AC Cab", "Pune to Vasai Intercity Cab"],
  ["Pune to Vasai Drop Taxi", "Pune to Vasai Travel Cab"],
  ["Pune to Virar Cab", "Pune to Virar Cab Service"],
  ["Pune to Virar Taxi", "Pune to Virar Taxi Service"],
  ["Pune to Virar Cab Booking", "Book Pune to Virar Cab"],
  ["Pune to Virar One Way Cab", "Pune to Virar Round Trip Cab"],
  ["Pune to Virar Outstation Cab", "Pune to Virar Car Rental"],
  ["Pune to Virar Private Cab", "Pune to Virar AC Cab"],
  ["Hinjewadi to Vasai Cab", "Wakad to Vasai Cab"],
  ["Baner to Vasai Cab", "Kharadi to Vasai Cab"],
  ["Hadapsar to Vasai Cab", "Pimpri Chinchwad to Vasai Cab"],
  ["Hinjewadi to Virar Cab", "Wakad to Virar Cab"],
  ["Baner to Virar Cab", "Kharadi to Virar Cab"],
  ["Hadapsar to Virar Cab", "Pimpri Chinchwad to Virar Cab"],
  ["Affordable Pune to Vasai and Virar Cab", "Best Pune to Vasai Cab Service"],
  ["Best Pune to Virar Cab Service", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Pune to Vasai & Virar Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable Pune to Vasai and Virar cab services for family trips, business travel, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Convenient Pickup Across Pune",
    WhyChoosedescription: "Get doorstep pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major locations in Pune."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Our professional chauffeurs are experienced in highway travel and ensure a safe, smooth, and timely journey to Vasai and Virar."
  },
  {
    WhyChooseheading: "Affordable Cab Fare with Transparency",
    WhyChoosedescription: "Travel with competitive pricing, clear fare details, and no hidden charges for your Pune to Vasai & Virar cab booking."
  },
  {
    WhyChooseheading: "Multiple Car Options Available",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your comfort and group size."
  },
  {
    WhyChooseheading: "One Way & Round Trip Services",
    WhyChoosedescription: "Book one-way cabs, return trips, or customized travel packages based on your preferred schedule."
  },
  {
    WhyChooseheading: "Perfect for Family & Corporate Travel",
    WhyChoosedescription: "Our Pune to Vasai and Virar cabs are suitable for family visits, office travel, business meetings, and personal journeys."
  },
  {
    WhyChooseheading: "Quick Booking & 24/7 Assistance",
    WhyChoosedescription: "Get instant quotations, fast booking confirmation, and reliable customer support whenever you need a cab."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Vasai & Virar cab service?",
    answer: "Yes, Trustline Cab offers reliable Pune to Vasai and Virar cab services for one-way trips, round trips, family travel, and corporate journeys."
  },
  {
    question: "Can I book a one-way cab from Pune to Vasai or Virar?",
    answer: "Yes, we provide affordable one-way cab services from Pune to Vasai and Virar with flexible pickup options."
  },
  {
    question: "Which vehicles are available for Pune to Vasai Virar travel?",
    answer: "We offer Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Do you provide pickup from Pune Airport and Railway Station?",
    answer: "Yes, we provide pickup from Pune Airport, Pune Railway Station, hotels, offices, and residential locations across Pune."
  },
  {
    question: "Can I book a round-trip cab to Vasai and Virar?",
    answer: "Yes, Trustline Travels offers flexible round-trip cab packages according to your travel requirements."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the booking quotation."
  },
  {
    question: "Is Pune to Vasai Virar cab service available 24/7?",
    answer: "Yes, our cab services are available 24 hours a day for convenient travel at any time."
  },
  {
    question: "Can I book an Innova Crysta for Vasai Virar travel?",
    answer: "Yes, Innova Crysta and other premium vehicles are available for comfortable family and group journeys."
  },
  {
    question: "Do you provide cabs for corporate and business travel?",
    answer: "Yes, our Pune to Vasai and Virar cab service is ideal for corporate meetings, employee travel, and business visits."
  },
  {
    question: "How can I book a Pune to Vasai & Virar cab with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Deshmukh",
    feedback: "Trustline Travels provided excellent Pune to Vasai cab service for our family trip. The driver was punctual, the vehicle was comfortable, and the entire journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Joshi",
    feedback: "We booked a cab from Pune to Virar and had a great experience. The booking was simple, pricing was clear, and the driver ensured a safe and comfortable ride.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Vasai & Virar Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-vasai-virar-cab.webp",
  "description": "Book Pune to Vasai and Virar cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, outstation, and private taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6217"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-vasai-virar-cab"
  }
};



  return (
    <div>


<Helmet>
  <title>Pune to Vasai Virar Cab | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Vasai & Virar cab service with Trustline Travels for reliable intercity travel. Get affordable one-way, round-trip, outstation, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to Vasai Cab, Pune to Vasai Cab Service, Pune to Vasai Taxi, Pune to Vasai Taxi Service, Pune to Vasai Cab Booking, Book Pune to Vasai Cab, Online Pune to Vasai Cab Booking, Pune to Vasai One Way Cab, Pune to Vasai Round Trip Cab, Pune to Vasai Outstation Cab, Pune to Vasai Car Rental, Pune to Vasai Private Cab, Pune to Vasai AC Cab, Pune to Vasai Intercity Cab, Pune to Virar Cab, Pune to Virar Taxi Service, Pune Vasai Virar cab booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/119.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetovasaivirarcab;